export default __webpack_public_path__ + "static/media/p13.e3a0d4ec.jpg";